import { Clock } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import type { RdsLockState } from '../../types/step5';

type RdsLockQueuedBannerProps = {
  rdsLock: RdsLockState | undefined;
};

export default function RdsLockQueuedBanner({ rdsLock }: RdsLockQueuedBannerProps) {
  if (!rdsLock || rdsLock.status !== 'QUEUED') {
    return null;
  }

  const holderRun = rdsLock.holder_run_id;
  const queuePosition = rdsLock.queue_position;
  const operation = rdsLock.holder_operation ?? 'operation';

  return (
    <div className="bg-blue-50 border border-solid border-blue-200 rounded-lg p-4 mb-4 flex items-start gap-3">
      <Clock className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
      <div className="text-sm text-blue-900">
        <p className="font-medium mb-1">
          <FormattedMessage
            id="steps.rdsLock.queued.title"
            defaultMessage="Waiting for shared project database"
          />
        </p>
        {holderRun != null ? (
          <p>
            <FormattedMessage
              id="steps.rdsLock.queued.withHolder"
              defaultMessage="Run {holderRun} is currently using the shared project database ({operation}). Your request is queued{positionSuffix} and will start automatically when it finishes."
              values={{
                holderRun,
                operation,
                positionSuffix:
                  queuePosition != null ? ` (position ${queuePosition})` : '',
              }}
            />
          </p>
        ) : (
          <p>
            <FormattedMessage
              id="steps.rdsLock.queued.generic"
              defaultMessage="Another run is using the shared project database. Your request is queued and will start automatically."
            />
          </p>
        )}
      </div>
    </div>
  );
}
